<template>
  <main-layout
    class="insurance"
    :page-title="title"
    @listen-back="goBack"
    customBack
    v-if="isshow"
    v-loading="loading"
  >
    <div slot="main-content" class="main-content">
      <component
        :handleTitle.sync="title"
        :is="currentStep"
        :insuranceId="insuranceId"
        ref="InsureJS"
        @buyInsure="buyInsure"
      ></component>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layout/MainLayout";
import conment from "@/views/Insurance/IntroducedJs/conment.vue";
import { getStorage, SessionStorage } from "@/utils/storage";
import { getOrderlist, checkEnableInsure } from "@/api/request/snkd.produce";
// import { windowHref } from "@/utils/index";
// ---------------->
import { mapState } from "vuex";

export default {
  name: "IntroducedJs",
  components: { MainLayout, conment },
  data() {
    return {
      currentStep: "conment",
      // 险种名称
      title: "",
      // 险种ID
      insuranceId: 1,
      insuranceName: "",
      // 判断来的页面
      pathWhere: getStorage("pathWhere") ? getStorage("pathWhere") : "",
      // 是否有订单列表
      listHave: [],
      // 是否显示页面
      isshow: false,
      insureInfo: {},
    };
  },
  computed: {
    ...mapState(["companyId", "farmId"]),
  },

  created() {
    this.insureInfo = SessionStorage.get("insureInfo");
    // this.title = this.$route.query.name;
    // this.insuranceId = this.$route.query.id;
    this.insuranceId = Number(this.$route.query.id);
    this.insuranceName = Number(this.$route.query.name);
    this.title = this.$route.query.name;
    console.log(":::", this.title);
    this.getInLists();
  },
  mounted() {},
  methods: {
    // 立即投保
    async buyInsure() {
      this.insureInfo = SessionStorage.get("insureInfo");
      if (this.$refs.InsureJS.hasInsure) {
        const res = await checkEnableInsure({
          insureId: this.$refs.InsureJS.list.find((item) => {
            return item.id === this.insureInfo.id;
          }).id,
          companyId: this.companyId,
          farmId: this.farmId,
        });

        if (res && res.respCode == 0) {
          this.$router.push({
            name: "Insure",
            query: {
              id: this.insuranceId,
              name: this.insuranceOneName,
            },
          });
        }
      }
      // if (this.$refs.InsureJS.hasInsure) {
      //   const res = await getInsureLandList({
      //     insureId: this.$refs.InsureJS.list[0].id,
      //     companyId: this.companyId,
      //     farmId: this.farmId,
      //   });
      //   console.log(res);
      //   if (res.respCode !== 0) {
      //     return;
      //   } else {
      //     this.$router.push("/insure");
      //   }
      // }
    },
    // 获取订单列表 --->
    async getInLists() {
      this.loading = true;
      const { respCode, obj } = await getOrderlist({
        companyId: this.companyId,
        farmId: this.farmId,
        pageNo: 1,
        pageSize: 20,
        insureId: this.insureInfo.id,
      });
      if (respCode === 0) {
        this.listHave = obj.list;
        this.loading = false;
        this.isshow = true;
      }
    },
    // 返回上一级跳转到列表页  判断返回页面
    goBack() {
      if (this.listHave.length) {
        if (this.pathWhere === "/") {
          this.$router.push("/insurance");
        } else {
          window.history.go(-1);
        }
      } else {
        // 回到主页insuranceList
        window.history.go(-1);
        // windowHref("/home/home");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.insurance {
  .main-content {
    min-height: calc(100% - 80px);
    height: 100%;
    overflow: auto;
    &::-webkit-scrollbar {
      width: 0;
    }
  }
}

::v-deep .common-page-header .title {
  font-size: 22px !important;
}
</style>
